import { useState, useEffect } from "react";
import { useLenis } from "lenis/react";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Products } from "@/components/site/Products";
import { Process } from "@/components/site/Process";
import { Fitment } from "@/components/site/Fitment";
import { Gallery } from "@/components/site/Gallery";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  const lenis = useLenis();
  const [selectedPart, setSelectedPart] = useState("");
  const [partNonce, setPartNonce] = useState(0);

  useEffect(() => {
    if (lenis) window.__lenis = lenis;
  }, [lenis]);

  const scrollTo = (target) =>
    lenis
      ? lenis.scrollTo(target, { offset: -60 })
      : document
          .querySelector(target)
          ?.scrollIntoView({ behavior: "smooth" });

  const onEnquire = (partName) => {
    setSelectedPart(partName || "");
    setPartNonce((n) => n + 1);
    scrollTo("#contact");
  };

  return (
    <main data-testid="landing-page">
      <Nav scrollTo={scrollTo} onEnquire={onEnquire} />
      <Hero scrollTo={scrollTo} onEnquire={onEnquire} />
      <Marquee />
      <Products onEnquire={onEnquire} />
      <Process />
      <Fitment />
      <Gallery />
      <FAQ />
      <Contact
        selectedPart={selectedPart}
        setSelectedPart={setSelectedPart}
        partNonce={partNonce}
      />
      <Footer scrollTo={scrollTo} onEnquire={onEnquire} />
    </main>
  );
}
